import React from 'react';
import PropTypes from 'prop-types';

import AccountLinkMessage from '../../components/AccountLinkMessage';
import SplitContainer from '../../connectedComponents/SplitContainer';

export default class SocialLinkedAccountPage extends React.Component {
    static propTypes = {
        handleSetLinkedAccount: PropTypes.func.isRequired,
        isLoading: PropTypes.bool,
        socialLinkedAccountStatus: PropTypes.string,
        onCloseButtonClick: PropTypes.func,
        usesNewStyles: PropTypes.bool,
    };

    componentDidMount() {
        const {
            router: {
                location: { query },
            },
        } = this.props;

        this.props.handleSetLinkedAccount(query);
    }

    // It is okay for this page to not render the secondary panel and do a takeover for the modal
    // Also this page should have headers and footers
    render() {
        const {
            isLoading,
            socialLinkedAccountStatus,
            onCloseButtonClick,
        } = this.props;

        return (
            <SplitContainer
                shouldShowSecondaryPanel={false}
                usesNewStyles={true}
                shouldUseFullWidth={true}
                header={null}
            >
                <AccountLinkMessage
                    status={socialLinkedAccountStatus}
                    isLoading={isLoading}
                    onCloseButtonClick={onCloseButtonClick}
                />
            </SplitContainer>
        );
    }
}
